module.exports = __webpack_public_path__ + "img/member_getCoupons_icon_431006.943ce3cf.png";